// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import { Checkbox } from "@insite/mobius/index";
import getColor from "@insite/mobius/utilities/getColor";
import React from "react";
import { css } from "styled-components";

interface BunzlToggleProps {
    isToggled: boolean;
    setIsToggled: (value: boolean) => void;
    label?: string;
    disabled?: boolean;
}
const BunzlToggle: React.FC<BunzlToggleProps> = ({
    isToggled,
    setIsToggled,
    label = translate("User has a Buying List"),
    disabled = false,
}) => {
    return (
        <Checkbox
            disabled={disabled}
            labelPosition="right"
            variant="toggle"
            checked={isToggled}
            css={css`
                div[role="checkbox"] {
                    border: ${getColor("whiteAlpha800")} 0.0625rem solid;
                }
                div[aria-checked="true"] {
                    background: ${getColor("secondary")};
                    &:focus {
                        box-shadow: 0 0 0 2px ${getColor("secondary")};
                    }
                }
                div[aria-checked="false"] {
                    &:focus {
                        box-shadow: 0 0 0 2px ${getColor("primary")};
                    }
                    background: ${getColor("primary")};
                }
            `}
            onChange={(_, value) => setIsToggled(value)}
        >
            {label}
        </Checkbox>
    );
};

export default BunzlToggle;
